import React, { useState } from 'react';
import GlobalUploadComp from '../../../../common/components/GlobalUploadComp/GlobalUploadComp';
import initialImg from '../../../../images/icons/upload_new.svg';
import pdf_solid from '../../../../images/icons/pdf.svg';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import { userBankAccountDelete } from '../../../../common/constants/api';
import Modal from '../../../../common/components/Modal/modal';
const ViewSalaryUploadedDetails = props => {
  const {
    values,
    data,
    setData,
    handleChange,
    errors,
    touched,
    handleBlur,
    setFieldError,
    setFieldValue,
    name,
    setFileUploadErrors,
    fileUploadErrors,
    setFieldTouched,
    handleSubmit,
    noOfUploadeneeded,
    fileLists,
    leadId,
    applicantId,
    setPopUpType,
    setPopUpText,
    setShow,
    invokeSaveAacountApi,
    setShowFiles,
    invokedSaveAccountApi,
    setSteps,
    setTogetdata
  } = props;

  const [ShowModal, setShowModal] = useState(false);

  const askConfirmagionOfDeletion = () => {
    setShowModal(true);
  };

  const handleEditEvent = async () => {
    await localStorage.setItem('userBankAccountRefId', fileLists.id);
    await setTogetdata(true);
    await setSteps('showSubmitButton');
  };

  const HandleDeleteAccount = async () => {
    setShowModal(false);
    await setPopUpText(
      <p className="font-roboto font-normal text-sm" style={{ color: 'red' }}>
        Deleting Bank Account
      </p>
    );
    await setPopUpType('loading');
    setShow(true);

    userBankAccountDelete(leadId, applicantId, fileLists.id)
      .then(async res => {
        if (res.error) {
          throw new Error(res.error.data.message);
        }
        setShow(false);
        await setShowFiles(false);
        invokeSaveAacountApi(!invokedSaveAccountApi);
      })
      .catch(async err => {
        await setPopUpType('fail');
        await setPopUpText(err.toString());
        setShow(true);
      });
  };
  const ViewDoc = image => {
    return (
      <div className="relative w-44 h-28 mx-auto" style={{ minWidth: '16rem' }}>
        <div
          id="img"
          onClick={e => {
            if (image) {
              window.open(image, '_blank');
            }
          }}
          className="w-44 h-28 bg-white my-2 relative mx-auto "
        >
          <img
            className="text-center mx-auto my-3"
            style={{ maxWidth: '200px' }}
            src={image}
            onError={e => {
              e.target.onerror = null;
              e.target.src = pdf_solid;
            }}
          />
        </div>
      </div>
    );
  };

  return (
    <div className="w-full">
      <div className="  w-full flex my-3">
        <div
          className="mr-auto  font-roboto font-normal cursor-pointer text-black-500 text-sm "
          onClick={() => {
            setShowFiles(false);
          }}
        >
          View All Account
        </div>
        <div
          className="mx-2 ml-auto cursor-pointer"
          onClick={e => {
            handleEditEvent();
          }}
        >
          <EditOutlinedIcon style={{ color: 'gray' }} />
        </div>
        <div
          className=" cursor-pointer"
          onClick={e => askConfirmagionOfDeletion(e)}
        >
          <DeleteOutlineOutlinedIcon style={{ color: 'gray' }} />
        </div>
      </div>
      <div className=" flex">
        {/* <img src="" alt="bankName" /> */}
        <p className="font-roboto font-bold text-sm text-black-500">
          {' '}
          {fileLists.bankName}
        </p>
      </div>
      <div className="w-full my-5 flex">
        <div className="mr-5">
          <p className="font-roboto font-normal text-xs text-black-500">
            Account Number
          </p>
          <p className="font-roboto font-bold text-sm text-black-500">
            {fileLists.accountNumber}
          </p>
        </div>
        <div className="">
          <p className="font-roboto font-normal text-xs text-black-500">
            IFSC Code
          </p>
          <p className="font-roboto font-bold text-sm text-black-500">
            {fileLists.ifscCode}
          </p>
        </div>
      </div>

      <div className="flex flex-wrap">
        {Array.isArray(fileLists.links)
          ? fileLists.links.map((each, index) => {
              return (
                <div className="   rounded  text-center pb-10 py-5 px-4">
                  <p className="font-roboto font-normal text-xs text-black-500 text-center">
                    {each.tag}
                  </p>

                  {ViewDoc(each.url)}
                </div>
              );
            })
          : null}
      </div>

      <Modal show={ShowModal} setShow={setShowModal} noCloseBtn={false}>
        <div className="">
          <div className="w-full text-center">
            <p className="font-roboto font-normal tex-black-0 text-center">
              Are you sure?.. You want to delete this account?
            </p>
          </div>
          <div className="w-full flex mt-8">
            <button
              className="bg-red-100 text-white px-3 py-2 border border-balck-500 rounded-md font-roboto font-normal"
              onClick={() => HandleDeleteAccount()}
            >
              Yes! I want to delete the account.
            </button>
            <button
              className="ml-auto  border border-balck-500 rounded font-roboto font-normal px-3 py-2"
              onClick={() => setShowModal(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ViewSalaryUploadedDetails;
